const ROUTE_PATHS = Object.freeze({
  root: "/",
  signIn: "/authentication/sign-in",
  signOut: "/authentication/sign-out",
  accountSettings: "/account/settings",
  accountBilling: "/account/billing",
  accountInvoices: "/account/invoices",
  accountInvoiceDetail: "/account/invoice-detail",
  tutorial: "/tutorial",
  pricing: "/pricing",
  siteManager: "/site-manager",
  overview: "/overview",
  degradationSoiling: "/degradation-soiling",
  serviceLife: "/service-life",
  powerGenerationForecast: "/power-generation-forecast",
  environmentalFinancial: "/environmental-financial",
  map: "/map",
});

export default ROUTE_PATHS;
